import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "flex min-h-screen items-center justify-center bg-slate-100 px-4 py-8 font-sans text-slate-950 sm:px-6",
  style: {"background":"url('/static/b1_cp.png') top center / cover no-repeat"}
}
const _hoisted_2 = { class: "grid w-full max-w-5xl overflow-hidden rounded-3xl bg-white shadow-2xl shadow-slate-900/10 md:min-h-[660px] md:grid-cols-[43%_57%]" }
const _hoisted_3 = { class: "relative overflow-hidden bg-blue-600 px-8 py-10 text-white sm:px-12 md:flex md:flex-col md:justify-between md:px-11 md:py-12" }
const _hoisted_4 = { class: "relative mt-12 md:mt-0" }
const _hoisted_5 = {
  key: 0,
  class: "mb-6 text-xs font-semibold tracking-wide text-white/70"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-6 text-xs font-semibold tracking-wide text-white/70"
}
const _hoisted_7 = {
  key: 2,
  "aria-label": "Signup progress"
}
const _hoisted_8 = {
  key: 0,
  class: "absolute top-9 border-l-2 left-[17px] h-[33px] border-white/20"
}
const _hoisted_9 = {
  key: 0,
  class: "h-5 w-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "mt-0.5 text-[13px] text-white/70" }
const _hoisted_12 = { class: "relative mt-10 text-[13px] text-white/70 md:mt-0" }
const _hoisted_13 = { class: "flex items-center justify-center px-7 py-12 sm:px-12 md:px-14" }
const _hoisted_14 = {
  class: "w-full text-center max-w-[400px]",
  key: "unavailable"
}
const _hoisted_15 = {
  key: 0,
  class: "mt-7 space-y-3",
  "aria-label": "Single sign-on options"
}
const _hoisted_16 = {
  key: 0,
  class: "flex w-full items-center justify-center gap-3 border border-gray-300 bg-white px-5 font-semibold text-gray-800 no-underline transition h-[50px] rounded-[10px] text-[15.5px] hover:border-gray-400 hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-blue-600/15",
  href: "/auth/oidc/google?intent=signup",
  "data-provider": "google"
}
const _hoisted_17 = {
  key: 1,
  class: "flex w-full items-center justify-center gap-3 border border-gray-300 bg-white px-5 font-semibold text-gray-800 no-underline transition h-[50px] rounded-[10px] text-[15.5px] hover:border-gray-400 hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-blue-600/15",
  href: "/auth/oidc/microsoft?intent=signup",
  "data-provider": "microsoft"
}
const _hoisted_18 = {
  key: 1,
  class: "flex items-center gap-4 py-5",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "mt-2 leading-6 text-gray-500 text-[14.5px]" }
const _hoisted_20 = { class: "font-semibold text-gray-600" }
const _hoisted_21 = { class: "mt-7" }
const _hoisted_22 = { class: "grid grid-cols-6 gap-2 px-8" }
const _hoisted_23 = ["onUpdate:modelValue", "autocomplete", "aria-label", "onInput", "onKeydown", "onPaste"]
const _hoisted_24 = { class: "mt-7 text-gray-500 text-[13.5px]" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "grid mt-7 grid-cols-1 gap-3 sm:grid-cols-2" }
const _hoisted_27 = { class: "block" }
const _hoisted_28 = { class: "block" }
const _hoisted_29 = { class: "mt-3 block" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "pointer-events-none absolute -left-28 -top-24 rounded-full border h-[340px] w-[340px] border-white/10" }, null, -1 /* HOISTED */)),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "pointer-events-none absolute -bottom-20 -right-16 rounded-full h-[220px] w-[220px] bg-white/[0.04]" }, null, -1 /* HOISTED */)),
        _cache[11] || (_cache[11] = _createElementVNode("a", {
          class: "relative text-2xl font-extrabold tracking-tight text-white no-underline",
          href: "/",
          "aria-label": "Tiga AI home"
        }, [
          _createTextVNode("Tiga"),
          _createElementVNode("span", { class: "text-white/70" }, ".ai")
        ], -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_4, [
          (!$options.isUnavailable)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Step " + _toDisplayString($options.activeIndex + 1) + " of 3", 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, "Trial availability")),
          (!$options.isUnavailable)
            ? (_openBlock(), _createElementBlock("ol", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.steps, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "relative flex gap-4 min-h-[69px] last:min-h-0",
                    key: item.id
                  }, [
                    (index < 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["relative grid h-9 w-9 flex-none place-items-center rounded-full text-sm font-bold transition-all duration-300", index === $options.activeIndex ? 'bg-white text-blue-600 ring-[5px] ring-white/20' : index < $options.activeIndex ? 'bg-white text-blue-600' : 'bg-white/10 text-white/75'])
                    }, [
                      (index < $options.activeIndex)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M16.704 5.293a1 1 0 0 1 .003 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8 12.586l7.293-7.293a1 1 0 0 1 1.411 0Z",
                              "clip-rule": "evenodd"
                            }, null, -1 /* HOISTED */)
                          ]))]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(index + 1), 1 /* TEXT */))
                    ], 2 /* CLASS */),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: _normalizeClass(["leading-5", index === $options.activeIndex ? 'font-bold' : 'font-semibold'])
                      }, _toDisplayString(item.title), 3 /* TEXT, CLASS */),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(index < $options.activeIndex ? item.complete : item.description), 1 /* TEXT */)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("p", _hoisted_12, _toDisplayString($options.footerText), 1 /* TEXT */)
      ]),
      _createElementVNode("section", _hoisted_13, [
        _createVNode(_Transition, {
          name: "step",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            ($options.isUnavailable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[12] || (_cache[12] = [
                  _createElementVNode("div", { class: "mx-auto grid h-14 w-14 place-items-center rounded-full bg-blue-50 text-blue-600" }, [
                    _createElementVNode("svg", {
                      class: "h-7 w-7",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.8",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M8.25 6.75h7.5m-7.5 3h7.5m-7.5 3h4.5m-6 6.75h10.5A2.25 2.25 0 0 0 19.5 17.25V5.25A2.25 2.25 0 0 0 17.25 3H6.75A2.25 2.25 0 0 0 4.5 5.25v12A2.25 2.25 0 0 0 6.75 19.5Z"
                      })
                    ])
                  ], -1 /* HOISTED */),
                  _createElementVNode("h1", { class: "mt-6 font-bold leading-tight tracking-tight text-[26px]" }, "Trial signups are currently full", -1 /* HOISTED */),
                  _createElementVNode("p", { class: "mt-3 leading-6 text-gray-500 text-[14.5px]" }, "We’ve reached our current trial capacity. Please check back later.", -1 /* HOISTED */),
                  _createElementVNode("p", { class: "mt-7 text-gray-500 text-[13.5px]" }, [
                    _createTextVNode("Already have an account? "),
                    _createElementVNode("a", {
                      class: "font-semibold text-blue-600 hover:underline",
                      href: "/login"
                    }, "Log in")
                  ], -1 /* HOISTED */)
                ])))
              : ($data.step === 'account')
                ? (_openBlock(), _createElementBlock("form", {
                    class: "w-full max-w-[400px]",
                    key: "account",
                    onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.submitAccount && $options.submitAccount(...args)), ["prevent"]))
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("header", null, [
                      _createElementVNode("h1", { class: "font-bold leading-tight tracking-tight text-[26px]" }, "Start your free trial"),
                      _createElementVNode("p", { class: "mt-2 leading-6 text-gray-500 text-[14.5px]" }, "Spin up your go-to-market workspace in under a minute.")
                    ], -1 /* HOISTED */)),
                    ($options.hasProviders)
                      ? (_openBlock(), _createElementBlock("nav", _hoisted_15, [
                          ($props.googleEnabled)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_16, _cache[13] || (_cache[13] = [
                                _createElementVNode("img", {
                                  class: "h-5 w-5",
                                  src: "/static/google-signin.svg",
                                  alt: "",
                                  "aria-hidden": "true"
                                }, null, -1 /* HOISTED */),
                                _createElementVNode("span", null, "Continue with Google", -1 /* HOISTED */)
                              ])))
                            : _createCommentVNode("v-if", true),
                          ($props.microsoftEnabled)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_17, _cache[14] || (_cache[14] = [
                                _createElementVNode("img", {
                                  class: "h-5 w-5",
                                  src: "/static/microsoft-signin.svg",
                                  alt: "",
                                  "aria-hidden": "true"
                                }, null, -1 /* HOISTED */),
                                _createElementVNode("span", null, "Continue with Microsoft", -1 /* HOISTED */)
                              ])))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($options.hasProviders)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[15] || (_cache[15] = [
                          _createElementVNode("div", { class: "h-px flex-1 bg-gray-200" }, null, -1 /* HOISTED */),
                          _createElementVNode("span", { class: "text-xs font-semibold tracking-wider text-gray-400" }, "OR USE YOUR EMAIL", -1 /* HOISTED */),
                          _createElementVNode("div", { class: "h-px flex-1 bg-gray-200" }, null, -1 /* HOISTED */)
                        ])))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("label", {
                      class: _normalizeClass(["block", $options.hasProviders ? '' : 'mt-7'])
                    }, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "sr-only" }, "Work email", -1 /* HOISTED */)),
                      _withDirectives(_createElementVNode("input", {
                        class: "w-full border-gray-300 px-4 shadow-none h-[50px] rounded-[10px] text-[15.5px] placeholder:text-gray-400 focus:border-blue-600 focus:ring-blue-600",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.email) = $event)),
                        type: "email",
                        autocomplete: "email",
                        placeholder: "you@company.com",
                        required: "required"
                      }, null, 512 /* NEED_PATCH */), [
                        [
                          _vModelText,
                          $data.email,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ], 2 /* CLASS */),
                    _createVNode(_component_ErrorMessage, { message: $data.error }, null, 8 /* PROPS */, ["message"]),
                    _createVNode(_component_SubmitButton, {
                      class: "mt-5",
                      loading: $data.loading,
                      "loading-label": "Sending code…"
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("Continue with email")
                      ])),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["loading"]),
                    _cache[19] || (_cache[19] = _createElementVNode("p", { class: "mt-4 text-gray-400 text-[12.5px] leading-[18.75px]" }, [
                      _createTextVNode("By continuing you agree to Tiga’s "),
                      _createElementVNode("a", {
                        class: "text-gray-500 hover:underline",
                        href: "https://www.tiga.ai/master-agreement"
                      }, "Terms"),
                      _createTextVNode(" & "),
                      _createElementVNode("a", {
                        class: "text-gray-500 hover:underline",
                        href: "https://www.tiga.ai/privacy-policy"
                      }, "Privacy Policy"),
                      _createTextVNode(".")
                    ], -1 /* HOISTED */)),
                    _cache[20] || (_cache[20] = _createElementVNode("p", { class: "mt-7 text-gray-500 text-[13.5px]" }, [
                      _createTextVNode("Already have an account? "),
                      _createElementVNode("a", {
                        class: "font-semibold text-blue-600 hover:underline",
                        href: "/login"
                      }, "Log in")
                    ], -1 /* HOISTED */))
                  ], 32 /* NEED_HYDRATION */))
                : ($data.step === 'verify')
                  ? (_openBlock(), _createElementBlock("form", {
                      class: "w-full max-w-[400px]",
                      key: "verify",
                      onSubmit: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.submitCode && $options.submitCode(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("header", null, [
                        _cache[24] || (_cache[24] = _createElementVNode("h1", { class: "font-bold leading-tight tracking-tight text-[26px]" }, "Verify your email", -1 /* HOISTED */)),
                        _createElementVNode("p", _hoisted_19, [
                          _cache[22] || (_cache[22] = _createTextVNode("Enter the verification code we sent")),
                          ($data.email)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[21] || (_cache[21] = _createTextVNode(" to ")),
                                _createElementVNode("strong", _hoisted_20, _toDisplayString($data.email), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          _cache[23] || (_cache[23] = _createTextVNode("."))
                        ])
                      ]),
                      _createElementVNode("fieldset", _hoisted_21, [
                        _cache[25] || (_cache[25] = _createElementVNode("legend", { class: "sr-only" }, "Verification code", -1 /* HOISTED */)),
                        _createElementVNode("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.code, (_, index) => {
                            return _withDirectives((_openBlock(), _createElementBlock("input", {
                              class: "h-12 w-full min-w-0 rounded-lg border-gray-300 p-0 text-center font-mono text-lg font-bold uppercase shadow-none focus:border-blue-600 focus:ring-blue-600",
                              key: index,
                              ref_for: true,
                              ref: element => $options.setCodeInput(element, index),
                              "onUpdate:modelValue": $event => (($data.code[index]) = $event),
                              type: "text",
                              maxlength: "1",
                              autocomplete: index === 0 ? 'one-time-code' : 'off',
                              "aria-label": `Verification code character ${index + 1}`,
                              onInput: $event => ($options.onCodeInput(index, $event)),
                              onKeydown: $event => ($options.onCodeKeydown(index, $event)),
                              onPaste: _withModifiers($event => ($options.onCodePaste(index, $event)), ["prevent"])
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_23)), [
                              [_vModelText, $data.code[index]]
                            ])
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]),
                      _createVNode(_component_ErrorMessage, { message: $data.error }, null, 8 /* PROPS */, ["message"]),
                      _createVNode(_component_SubmitButton, {
                        class: "mt-5",
                        loading: $data.loading,
                        "loading-label": "Verifying…"
                      }, {
                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createTextVNode("Verify email")
                        ])),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["loading"]),
                      _createElementVNode("p", _hoisted_24, [
                        _cache[27] || (_cache[27] = _createTextVNode("Used the wrong email? ")),
                        _createElementVNode("button", {
                          class: "font-semibold text-blue-600 hover:underline disabled:cursor-wait disabled:opacity-60",
                          type: "button",
                          disabled: $data.loading,
                          onClick: _cache[2] || (_cache[2] = (...args) => ($options.startOver && $options.startOver(...args)))
                        }, _toDisplayString($data.loading ? "Starting over…" : "Start over"), 9 /* TEXT, PROPS */, _hoisted_25)
                      ])
                    ], 32 /* NEED_HYDRATION */))
                  : (_openBlock(), _createElementBlock("form", {
                      class: "w-full max-w-[400px]",
                      key: "profile",
                      onSubmit: _cache[7] || (_cache[7] = _withModifiers((...args) => ($options.submitProfile && $options.submitProfile(...args)), ["prevent"]))
                    }, [
                      _cache[32] || (_cache[32] = _createElementVNode("header", null, [
                        _createElementVNode("h1", { class: "font-bold leading-tight tracking-tight text-[26px]" }, "Complete your profile"),
                        _createElementVNode("p", { class: "mt-2 leading-6 text-gray-500 text-[14.5px]" }, "Tell us a little about you and your company.")
                      ], -1 /* HOISTED */)),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("label", _hoisted_27, [
                          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "sr-only" }, "First name", -1 /* HOISTED */)),
                          _withDirectives(_createElementVNode("input", {
                            class: "w-full border-gray-300 px-4 shadow-none h-[50px] rounded-[10px] text-[15.5px] placeholder:text-gray-400 focus:border-blue-600 focus:ring-blue-600",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.firstName) = $event)),
                            type: "text",
                            autocomplete: "given-name",
                            maxlength: "255",
                            placeholder: "First name",
                            required: "required"
                          }, null, 512 /* NEED_PATCH */), [
                            [
                              _vModelText,
                              $data.firstName,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_28, [
                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "sr-only" }, "Last name", -1 /* HOISTED */)),
                          _withDirectives(_createElementVNode("input", {
                            class: "w-full border-gray-300 px-4 shadow-none h-[50px] rounded-[10px] text-[15.5px] placeholder:text-gray-400 focus:border-blue-600 focus:ring-blue-600",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.lastName) = $event)),
                            type: "text",
                            autocomplete: "family-name",
                            maxlength: "255",
                            placeholder: "Last name",
                            required: "required"
                          }, null, 512 /* NEED_PATCH */), [
                            [
                              _vModelText,
                              $data.lastName,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_29, [
                        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "sr-only" }, "Company name", -1 /* HOISTED */)),
                        _withDirectives(_createElementVNode("input", {
                          class: "w-full border-gray-300 px-4 shadow-none h-[50px] rounded-[10px] text-[15.5px] placeholder:text-gray-400 focus:border-blue-600 focus:ring-blue-600",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.companyName) = $event)),
                          type: "text",
                          autocomplete: "organization",
                          maxlength: "255",
                          placeholder: "Company name",
                          required: "required"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            $data.companyName,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createVNode(_component_ErrorMessage, { message: $data.error }, null, 8 /* PROPS */, ["message"]),
                      _createVNode(_component_SubmitButton, {
                        class: "mt-5",
                        loading: $data.loading,
                        "loading-label": "Finishing setup…"
                      }, {
                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                          _createTextVNode("Finish setup")
                        ])),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["loading"])
                    ], 32 /* NEED_HYDRATION */))
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}